// extracted by mini-css-extract-plugin
export default {"headInfoContainer":"HeadInfo_headInfoContainer__Ryv7u","infoCard":"HeadInfo_infoCard__r0z8g","cardValues":"HeadInfo_cardValues__3ba3J"};